export const outterMessage = (status: number): string => {
    let message = "";
    switch (status) {
      case 400:
        message = "请求错误(400)";
        break;
      case 401:
        message = "未授权，请重新登录(401)";
        break;
      case 403:
        message = "拒绝访问(403)";
        break;
      case 404:
        message = "请求出错(404)";
        break;
      case 408:
        message = "请求超时(408)";
        break;
      case 500:
        message = "服务器错误(500)";
        break;
      case 501:
        message = "服务未实现(501)";
        break;
      case 502:
        message = "服务错误(502)";
        break;
      case 503:
        message = "服务器不可用(503)";
        break;
      case 504:
        message = "网络超时(504)";
        break;
      case 505:
        message = "HTTP版本不受支持(505)";
        break;
      default:
        message = `连接出错(${status})`;
    }
    return `${message}, 请检查网络或联系网站管理员~`;
  };
  
  export const innerMessage = function (status: string, msg: string): string {
    let message = "";
    switch (status) {
      case "bio-1002":
        message = msg || "用户名密码错误";
        break;
      case "bio-1003":
        message = msg || "用户不存在";
        break;
      case "bio-1004":
        message = msg || "登录超时";
        break;
      case "bio-1005":
        message = msg || "token即将过期，新token放在message";
        break;
      case "bio-1006":
        message = msg || "用户信息有误，当前用户id和单位id不一致";
        break;
      case "bio-11111":
        message =msg || "请求参数不符合要求，请检查用户id，单位id，应用标识，token不能为空";
        break;
  
      default:
        message = msg || "内部错误";
        break;
    }
    return `${message}`;
  };
  
  // 接口成功code
  export const successCode = "bio-99999";
  // token即将过期code
  export const refreshTokenCode = "bio-1005";
  // token过期code
  export const reloginCode = "bio-1004";
  